"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mapi_1 = require("@unimaze/api-clients/lib/mapi");
var antd_1 = require("antd");
var formLayout_1 = require("../common/consts/formLayout");
var components_1 = require("../common/components");
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var utils_1 = require("../utils");
var BillingLineUtility_1 = require("../utils/BillingLineUtility");
var paymentMethodForConversion_1 = require("../common/components/payment-method/paymentMethodForConversion");
var uuid_1 = require("uuid");
var ApiUtility_1 = require("../utils/ApiUtility");
var ConversionUtility_1 = require("../utils/ConversionUtility");
var reaptcha_1 = __importDefault(require("reaptcha"));
var translationMessages = react_intl_1.defineMessages({
    createInvoice_addDocumentLineMsg: {
        id: "createInvoice_addDocumentLineMsg",
        defaultMessage: "Add at least one document line",
    },
    createInvoice_selectCustomerMsg: {
        id: "createInvoice_selectCustomerMsg",
        defaultMessage: "Customer must be selected",
    },
    createInvoice_successfullySubmittedInvoiceMsg: {
        id: "createInvoice_successfullySubmittedInvoiceMsg",
        defaultMessage: "Successfully submitted the invoice"
    },
    createInvoice_successfullyUploadedAttachmentMsg: {
        id: "createInvoice_successfullyUploadedAttachmentMsg",
        defaultMessage: "Successfully uploaded attachment {attachment}"
    },
    createInvoice_ErrorUploadedAttachmentMsg: {
        id: "createInvoice_ErrorUploadedAttachmentMsg",
        defaultMessage: "Error uploaded attachment {attachment}"
    },
    createInvoice_Submit: {
        id: "createInvoice_Submit",
        defaultMessage: "Submit"
    },
    createInvoice_SendCopy: {
        id: "createInvoice_SendCopy",
        defaultMessage: "Send a copy"
    },
    createInvoice_SendCopyTooltip: {
        id: "createInvoice_SendCopyTooltip",
        defaultMessage: "Sends you a PDF copy of the invoice"
    },
    createInvoice_SendCopyTooltipDisabled: {
        id: "createInvoice_SendCopyTooltipDisabled",
        defaultMessage: "You must fill in your email address to send yourself a copy"
    },
});
/**
 * Component for creating a form for creating an invoice and submitting it to the MAPI transaction services
 *
 * @component
 */
var CreateInvoiceConstructor = function (props) {
    var recaptchaRef = react_1.default.useRef(null);
    var intl = props.intl;
    var form = antd_1.Form.useForm()[0];
    var _a = react_1.useState(false), submitting = _a[0], setSubmitting = _a[1];
    var _b = react_1.useState(true), isSubmitDisabled = _b[0], setIsSubmitDisabled = _b[1];
    var _c = react_1.useState(ConversionUtility_1.profileOutputToPartyMetadata(props.customers[0])), chosenCustomer = _c[0], setChosenCustomer = _c[1];
    var _d = react_1.useState(props.customers[0].apiKey), chosenCustomerApiKey = _d[0], setChosenCustomerApiKey = _d[1];
    var _e = react_1.useState(true), sendCopyDisabled = _e[0], setSendCopyDisabled = _e[1];
    var _f = react_1.useState(false), sendCopy = _f[0], setSendCopy = _f[1];
    var _g = react_1.default.useState(""), referenceIdentifierValidateStatus = _g[0], setReferenceIdentifierValidateStatus = _g[1];
    // const [billingLinesEditableIndex, setBillingLinesEditableIndex] = useState<number>(1)
    var _h = react_1.useState(false), outsideVatScope = _h[0], setOutsideVatScope = _h[1];
    var _j = react_1.useState(false), captchaVerified = _j[0], setCaptchaVerified = _j[1];
    react_1.useEffect(function () {
        setIsSubmitDisabled(!captchaVerified);
    }, [captchaVerified]);
    // attachments
    // TODO: remove the states, set the values to the form in attachment components
    var _k = react_1.useState([]), file1 = _k[0], setFile1 = _k[1];
    var _l = react_1.useState(""), attachmentFieldValidation1 = _l[0], setAttachmentFieldValidation1 = _l[1];
    var _m = react_1.useState([]), file2 = _m[0], setFile2 = _m[1];
    var _o = react_1.useState(""), attachmentFieldValidation2 = _o[0], setAttachmentFieldValidation2 = _o[1];
    var _p = react_1.useState([]), file3 = _p[0], setFile3 = _p[1];
    var _q = react_1.useState(""), attachmentFieldValidation3 = _q[0], setAttachmentFieldValidation3 = _q[1];
    react_1.useEffect(function () {
        form.resetFields([
            ["invoice", "supplier", "vatNumber"],
        ]);
        var invoiceLines = form.getFieldValue(["invoice", "invoiceLines"]);
        if (outsideVatScope) {
            invoiceLines = invoiceLines.map(function (invoiceLine) {
                invoiceLine.taxCategoryType = mapi_1.TaxCategoryTypeEnum.OutsideTaxScope;
                return invoiceLine;
            });
        }
        else {
            invoiceLines = invoiceLines.map(function (invoiceLine) {
                invoiceLine.taxCategoryType = mapi_1.TaxCategoryTypeEnum.StandardRated;
                return invoiceLine;
            });
        }
        form.setFieldsValue({
            invoice: {
                invoiceLines: invoiceLines
            }
        });
    }, [outsideVatScope]);
    var resetAttachments = function () {
        setFile1([]);
        setAttachmentFieldValidation1("");
        setFile2([]);
        setAttachmentFieldValidation2("");
        setFile3([]);
        setAttachmentFieldValidation3("");
    };
    var supplierEmailValue = form.getFieldValue(["invoice", "supplier", "contact", "electronicMail"]);
    react_1.useEffect(function () {
        if (supplierEmailValue) {
            form.validateFields([["invoice", "supplier", "contact", "electronicMail"]])
                .then(function () {
                setSendCopyDisabled(!supplierEmailValue);
                setSendCopy(true);
            })
                .catch(function () {
                setSendCopyDisabled(true);
                setSendCopy(false);
            });
        }
        else {
            setSendCopy(false);
            setSendCopyDisabled(true);
        }
    }, [supplierEmailValue]);
    var handleSubmit = function (values) {
        setSubmitting(true);
        if (referenceIdentifierValidateStatus !== "" && referenceIdentifierValidateStatus !== "success") {
            form.scrollToField(["invoice", "referenceIdentifiers", 0, "value"]);
            setSubmitting(false);
            return;
        }
        var attachments = [
            values.attachments.file1 && values.attachments.file1,
            values.attachments.file2 && values.attachments.file2,
            values.attachments.file3 && values.attachments.file3,
        ];
        // Clear the array of undefined
        attachments = attachments.filter(function (attachment) { return (attachment.file !== undefined) && (attachment.file && attachment.file.length > 0); });
        if (!chosenCustomer) {
            antd_1.message.error(intl.formatMessage(translationMessages.createInvoice_selectCustomerMsg));
            // TODO: handle this better?
            setSubmitting(false);
            return;
        }
        var services = sendCopy
            ? ["urn:services:dispatcher:mail.pdf?email=" + supplierEmailValue + "#$#lang=" + props.language]
            : undefined;
        var invoiceMetadataInput = utils_1.convertToInvoiceMetadataInput(values, BillingLineUtility_1.billingLinesFieldsMetadata(form), paymentMethodForConversion_1.PaymentMethodFormData(values), chosenCustomer);
        var createSubmitInvoice = {
            invoiceMetadataInput: invoiceMetadataInput,
            more: attachments.length > 0,
            messageId: uuid_1.v4(),
            processingMode: mapi_1.TransactionProcessingMode.Device,
            services: services
            // processingMode: TransactionProcessingMode.DeviceRouted
        };
        utils_1.submitInvoice(createSubmitInvoice, props.mapiBaseUrl, chosenCustomerApiKey, "submitInvoice", props.language)
            .then(function (resp) {
            antd_1.message.success(intl.formatMessage(translationMessages.createInvoice_successfullySubmittedInvoiceMsg));
            var messageId = resp.data.uniqueId;
            var _loop_1 = function () {
                var nextFileArray = attachments.splice(0, 1);
                var nextFile = nextFileArray[0].file[0].originFileObj;
                var nextFileDescription = nextFileArray[0].description;
                if (!nextFile)
                    throw new Error("NextFile is empty");
                var createAttachDocument = {
                    messageId: messageId,
                    contentType: nextFile.type,
                    more: attachments.length > 0,
                    name: nextFileDescription // nextFile.name,
                };
                setSubmitting(true);
                ApiUtility_1.submitDocumentFetch(nextFile, createAttachDocument, props.mapiBaseUrl, chosenCustomerApiKey)
                    .then(function (submitDocumentResponse) {
                    antd_1.message.success(intl.formatMessage(translationMessages.createInvoice_successfullyUploadedAttachmentMsg, { attachment: nextFileDescription }));
                    setSubmitting(false);
                })
                    .catch(function (documentSendingErrorMessage) {
                    antd_1.message.error(intl.formatMessage(translationMessages.createInvoice_ErrorUploadedAttachmentMsg, { attachment: nextFileDescription }) + " - " + documentSendingErrorMessage.message);
                    setSubmitting(false);
                });
            };
            while (attachments.length > 0) {
                _loop_1();
            }
            setSubmitting(false);
            form.resetFields();
            form.setFields([
                {
                    name: ["invoice", "invoiceLines"],
                    value: [{}]
                },
                {
                    name: ["invoice", "supplier"],
                    value: values.invoice.supplier,
                },
                {
                    name: ["outsideVatScope"],
                    value: !values.invoice.supplier.vatNumber
                },
                {
                    name: ["attachments"],
                    value: {
                        file1: { file: undefined, description: undefined },
                        file2: { file: undefined, description: undefined },
                        file3: { file: undefined, description: undefined },
                    }
                }
            ]);
            resetAttachments();
            // Clear the billing line dataSource
            setChosenCustomer(ConversionUtility_1.profileOutputToPartyMetadata(props.customers[0]));
            setChosenCustomerApiKey(props.customers[0].apiKey);
            // setBillingLinesDataSource([{...initialBillingLineData, key: 0}])
            // setBillingLinesEditableIndex(0);
            // TODO: remove this as soon as possible
            // location.reload();
        })
            .catch(function (error) {
            setSubmitting(false);
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                if (error.response.data) {
                    var errorData = error.response.data;
                    if (errorData.hasOwnProperty("message")) {
                        antd_1.message.error(errorData.message);
                    }
                    else {
                        for (var errorMessageKey in errorData) {
                            if (errorData.hasOwnProperty(errorMessageKey)) {
                                antd_1.message.error(react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("strong", null, errorMessageKey),
                                    react_1.default.createElement("br", null),
                                    errorData[errorMessageKey]));
                            }
                        }
                    }
                }
            }
            else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                var request = error.request;
                antd_1.message.error(request.responseText);
            }
            else {
                // Something happened in setting up the request that triggered an Error
                antd_1.message.error(error.message);
            }
        });
        if (recaptchaRef) {
            if (recaptchaRef.current) {
                recaptchaRef.current.reset();
            }
        }
        setIsSubmitDisabled(true);
    };
    react_1.useEffect(function () {
        getReceiverRequirements();
    }, [chosenCustomer]);
    var getReceiverRequirements = function () {
        if (chosenCustomer) {
            form.resetFields([
                ["invoice", "referenceIdentifiers"],
                ["invoice", "customer", "locationIdentifier"],
                ["invoice", "paymentMeans"]
            ]);
            props.getReceiverRequirements(props.rapiBaseUrl, chosenCustomer.identifier);
        }
    };
    var defaultCustomer;
    if (props.customers.length === 1 && !chosenCustomer) {
        defaultCustomer = props.customers[0];
        setChosenCustomer({
            contact: {
                electronicMail: defaultCustomer.email,
                telephone: defaultCustomer.phoneNumber,
            },
            address: {
                countryCode: defaultCustomer.country,
                city: defaultCustomer.participantLegalAddressCity,
                postalZone: defaultCustomer.participantLegalAddressPostalCode,
                streetNameAndNumber: defaultCustomer.participantLegalAddressStreet,
            },
            identifier: defaultCustomer.participantLegalIsoIdentifier,
            name: defaultCustomer.name
        });
        setChosenCustomerApiKey(props.customers[0].apiKey);
    }
    var _r = react_1.useState(undefined), billingLinesMetadata = _r[0], setBillingLinesMetadata = _r[1];
    var getBillingLines = function (changedValues, allValues) {
        var invoiceLines = allValues.invoice.invoiceLines;
        if (invoiceLines) {
            var mappedBillingLines = invoiceLines.map(function (invoiceLine) {
                if (invoiceLine) {
                    return ({
                        itemNo: invoiceLine.itemNo ? invoiceLine.itemNo : undefined,
                        name: invoiceLine.name ? invoiceLine.name : undefined,
                        quantity: invoiceLine.quantity ? invoiceLine.quantity : undefined,
                        unitPriceAmount: invoiceLine.unitPriceAmount ? invoiceLine.unitPriceAmount : undefined,
                        unitOfMeasure: {
                            unit: invoiceLine.unitOfMeasure && invoiceLine.unitOfMeasure.unit ? mapi_1.Units[invoiceLine.unitOfMeasure.unit] : undefined,
                        },
                        taxCategoryType: invoiceLine.taxCategoryType ? mapi_1.TaxCategoryTypeEnum[invoiceLine.taxCategoryType] : undefined,
                        discountValue: invoiceLine.discountValue ? invoiceLine.discountValue : undefined,
                    });
                }
                else {
                    return {};
                }
            });
            setBillingLinesMetadata(mappedBillingLines);
        }
    };
    var getDefaultPaymentType = function (defaultPaymentType) {
        return defaultPaymentType || mapi_1.PaymentMeansType.DomesticClaim;
    };
    return (react_1.default.createElement(antd_1.Spin, { spinning: submitting },
        react_1.default.createElement(antd_1.Form, __assign({ onFieldsChange: function () {
                if (captchaVerified && recaptchaRef) {
                    if (recaptchaRef.current) {
                        setCaptchaVerified(false);
                        recaptchaRef.current.reset();
                    }
                }
            }, scrollToFirstError: true, onValuesChange: function (changedValues, allValues) { return getBillingLines(changedValues, allValues); } }, formLayout_1.formItemLayout, { form: form, onFinish: handleSubmit, initialValues: {
                invoice: {
                    supplier: {
                        address: {
                            countryCode: "IS"
                        },
                    },
                    customer: __assign({}, chosenCustomer, { address: {
                            countryCode: "IS"
                        } }),
                    paymentMeans: {
                        type: getDefaultPaymentType(props.defaultPaymentType),
                    },
                    referenceIdentifiers: [
                        {}
                    ],
                    singleReferenceIdentifier: {
                        code: undefined
                    },
                    invoiceLines: [{}],
                    attachments: {
                        file1: { file: undefined, description: undefined },
                        file2: { file: undefined, description: undefined },
                        file3: { file: undefined, description: undefined },
                    }
                },
            } }),
            react_1.default.createElement(antd_1.Row, { gutter: [16, 16] },
                react_1.default.createElement(antd_1.Col, { xs: { span: 24 }, md: { span: 8 } },
                    react_1.default.createElement(antd_1.Form.Item, { noStyle: true, name: ["invoice", "singleReferenceIdentifier", "code"] },
                        react_1.default.createElement(antd_1.Input, { type: "hidden" })),
                    react_1.default.createElement(components_1.Supplier, { receiverRequirements: props.receiverRequirements, 
                        // billingLinesDataSource={billingLinesDataSource}
                        rapiBaseUrl: props.rapiBaseUrl, rapiApiKey: props.rapiApiKey, form: form, outsideVatScope: outsideVatScope, setOutsideVatScope: setOutsideVatScope })),
                react_1.default.createElement(antd_1.Col, { xs: { span: 24 }, md: { span: 8 } },
                    react_1.default.createElement(components_1.Customer, { receiverRequirements: props.receiverRequirements, formInstance: form, customers: props.customers, chosenCustomer: chosenCustomer, setChosenCustomer: setChosenCustomer, setChosenCustomerApiKey: setChosenCustomerApiKey, rapiBaseUrl: props.rapiBaseUrl, updateReceiverRequirementsProp: props.updateReceiverRequirementsProp })),
                react_1.default.createElement(antd_1.Col, { xs: { span: 24 }, md: { span: 8 } },
                    react_1.default.createElement(components_1.BaseInformation, { receiverRequirements: props.receiverRequirements, form: form, documentType: "invoice", updateReceiverRequirementsProp: props.updateReceiverRequirementsProp, rapiBaseUrl: props.rapiBaseUrl, legalIdentifier: chosenCustomer.identifier, referenceIdentifiersLabelText: props.referenceIdentifiersLabelText, referenceIdentifiersHelpText: props.referenceIdentifiersHelpText, referenceIdentifierValidateStatus: referenceIdentifierValidateStatus, setReferenceIdentifierValidateStatus: setReferenceIdentifierValidateStatus, dueDateMinimumOffset: props.dueDateMinimumOffset })),
                react_1.default.createElement(antd_1.Col, { xs: { span: 24 }, md: { span: 24 } },
                    react_1.default.createElement(components_1.BillingLines
                    // setBillingLineMetadata={handleSetBillingLineMetadata}
                    , { 
                        // setBillingLineMetadata={handleSetBillingLineMetadata}
                        formInstance: form, billingLinesMetadata: billingLinesMetadata, 
                        // editableIndex={billingLinesEditableIndex}
                        // handleAdd={handleBillingLinesAdd}
                        // initialBillingLineData={initialBillingLineData}
                        // handleDelete={handleBillingLinesDelete}
                        // handleSave={handleBillingLinesSave}
                        receiverRequirements: props.receiverRequirements, outsideVatScope: outsideVatScope })),
                react_1.default.createElement(antd_1.Col, { xs: { span: 24 }, md: { span: 8 } },
                    react_1.default.createElement(components_1.PaymentMethod, { receiverRequirements: props.receiverRequirements, formInstance: form })),
                react_1.default.createElement(antd_1.Col, { xs: { span: 24 }, md: { span: 16 } },
                    react_1.default.createElement(components_1.Attachments, { formInstance: form, uploadSizeLimit: props.uploadSizeLimit, attachmentTooltipText: props.attachmentTooltipText, languageString: props.language, file1: file1, setFile1: setFile1, attachmentFieldValidation1: attachmentFieldValidation1, setAttachmentFieldValidation1: setAttachmentFieldValidation1, file2: file2, setFile2: setFile2, attachmentFieldValidation2: attachmentFieldValidation2, setAttachmentFieldValidation2: setAttachmentFieldValidation2, file3: file3, setFile3: setFile3, attachmentFieldValidation3: attachmentFieldValidation3, setAttachmentFieldValidation3: setAttachmentFieldValidation3 })),
                react_1.default.createElement(antd_1.Row, { style: { width: "100%", padding: "8px" }, justify: "end" },
                    react_1.default.createElement(antd_1.Col, null,
                        react_1.default.createElement(reaptcha_1.default, { sitekey: "6LdMUdEZAAAAAG--2WEyu8CIRVlv6CzdZIwaQ-zt", ref: recaptchaRef, onVerify: function (response) {
                                setCaptchaVerified(true);
                            }, hl: props.language, onExpire: function () { return setCaptchaVerified(false); }, onError: function () { return setCaptchaVerified(false); } }))),
                react_1.default.createElement(antd_1.Row, { style: { width: "100%", padding: "8px" }, justify: "end" },
                    react_1.default.createElement(antd_1.Col, null,
                        react_1.default.createElement(antd_1.Tooltip, { title: sendCopyDisabled ? intl.formatMessage(translationMessages.createInvoice_SendCopyTooltipDisabled) : intl.formatMessage(translationMessages.createInvoice_SendCopyTooltip) },
                            react_1.default.createElement(antd_1.Checkbox, { disabled: sendCopyDisabled, checked: sendCopy, onChange: function (e) { return setSendCopy(e.target.checked); } }, intl.formatMessage(translationMessages.createInvoice_SendCopy)))),
                    react_1.default.createElement(antd_1.Col, null,
                        react_1.default.createElement(antd_1.Button, { type: "primary", htmlType: "submit", size: "large", disabled: isSubmitDisabled }, intl.formatMessage(translationMessages.createInvoice_Submit))))))));
};
exports.default = react_intl_1.injectIntl(CreateInvoiceConstructor);
